module.exports = function findRegionById(regions, id) {
	var res;
	regions.each(function(reg) {
		if(parseInt(reg.properties.get('osmId'), 10) === id) {
			res = reg;
		}
	});
	
	return res ? res : id;
};


/** WEBPACK FOOTER **
 ** ./src/scripts/lib/contacts/fn/findRegionById.js
 **/